import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights, palette,
}: Theme) => ({
  paper: {
    '&&': {
      width: '95vw',
      maxWidth: '100%',
      borderRadius: '0.5rem',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      [breakpoints.up('md')]: {
        width: '34.875rem',
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  title: {
    fontWeight: fontWeights.medium,
    '&&': {
      marginBottom: '1.5rem',
      [breakpoints.up('md')]: {
        fontSize: '1.75rem',
        lineHeight: 1.3,
      },
    },
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 0 2rem',
    padding: '1rem',
    border: `1px solid ${palette.grey[400]}`,
    borderTop: 0,
    borderBottomLeftRadius: '1rem',
    borderBottomRightRadius: '1rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    textAlign: 'center',
  },
  label: {
    display: 'block',
    margin: '0.5rem auto 0',
    padding: '0.25rem',
    borderRadius: '0.25rem',
    background: palette.custom.main,
    color: palette.common.white,
    fontSize: '0.6875rem',
    lineHeight: 1.1,
    fontWeight: fontWeights.medium,
  },
  download: {
    gap: '0.75rem',
    margin: '0 auto 1.5rem',
    fontWeight: fontWeights.medium,
  },
  button: {
    width: '100%',
  },
}));
